/* ============================================================
   Café Société – KITH-style Product Gallery Controller
   All images stacked vertically. Thumbnails act as navigation:
     • Click thumbnail → smooth-scroll to that image
     • Scroll spy → highlight the thumbnail of the visible image
   ============================================================ */
(function () {
  'use strict';

  var INIT_FLAG = 'cs-gallery-init';

  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function initGallery() {
    if (!isDesktop()) return;

    var gallery = document.querySelector('media-gallery.product__column-sticky');
    if (!gallery) return;
    if (gallery.getAttribute('data-' + INIT_FLAG)) return;

    var mediaItems = gallery.querySelectorAll('.product__media-item');
    var thumbnails = gallery.querySelectorAll('.thumbnail-list__item .thumbnail');

    if (mediaItems.length < 2 || thumbnails.length < 2) return;

    gallery.setAttribute('data-' + INIT_FLAG, '1');

    // ---- Disable Dawn's scroll-snap slider behavior ----
    var mainSlider = gallery.querySelector('slider-component:not(.thumbnail-slider)');
    if (mainSlider) {
      var sliderEl = mainSlider.querySelector('.slider');
      if (sliderEl) {
        sliderEl.style.scrollSnapType = 'none';
        sliderEl.style.overflow = 'visible';
      }
      // Neuter Dawn's slider methods
      if (typeof mainSlider.update === 'function') {
        mainSlider.update = function () {};
      }
      if (typeof mainSlider.setSlidePosition === 'function') {
        mainSlider.setSlidePosition = function () {};
      }
      if (typeof mainSlider.onSlideChange === 'function') {
        mainSlider.onSlideChange = function () {};
      }
    }

    // ---- Set first thumbnail as active initially ----
    setActiveThumbnail(thumbnails, 0);

    // ---- Thumbnail click → scroll to image ----
    var thumbSlider = gallery.querySelector('.thumbnail-slider');
    if (thumbSlider) {
      thumbSlider.addEventListener('click', function (e) {
        if (!isDesktop()) return;
        var thumb = e.target.closest('.thumbnail');
        if (!thumb) return;

        var index = getThumbIndex(thumbnails, thumb);
        if (index < 0 || index >= mediaItems.length) return;

        e.preventDefault();
        e.stopPropagation();

        // Smooth-scroll to the target image
        var headerHeight = getHeaderHeight();
        var targetTop = mediaItems[index].getBoundingClientRect().top + window.scrollY - headerHeight - 20;

        window.scrollTo({ top: targetTop, behavior: 'smooth' });
        setActiveThumbnail(thumbnails, index);
      }, true);
    }

    // ---- Scroll spy: update active thumbnail as user scrolls ----
    var scrollTimeout;
    window.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        updateActiveThumbnailOnScroll(mediaItems, thumbnails);
      }, 50);
    }, { passive: true });

    // Initial check
    updateActiveThumbnailOnScroll(mediaItems, thumbnails);

    // ---- Fix: reset scrollTop after lightbox closes ----
    // Dawn's product-modal (or browser focus handling) can set scrollTop
    // on overflow:hidden media items when the zoom dialog opens/closes.
    // This leaves the image scrolled out of view. Prevent it by resetting
    // scrollTop to 0 whenever it changes on these items.
    mediaItems.forEach(function (item) {
      item.addEventListener('scroll', function () {
        if (item.scrollTop !== 0) item.scrollTop = 0;
      });
    });
  }

  function getHeaderHeight() {
    var header = document.querySelector('.section-header');
    return header ? header.offsetHeight : 0;
  }

  function getThumbIndex(thumbnails, thumb) {
    for (var i = 0; i < thumbnails.length; i++) {
      if (thumbnails[i] === thumb) return i;
    }
    return -1;
  }

  function setActiveThumbnail(thumbnails, activeIndex) {
    thumbnails.forEach(function (thumb, i) {
      if (i === activeIndex) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  }

  function updateActiveThumbnailOnScroll(mediaItems, thumbnails) {
    var headerHeight = getHeaderHeight();
    var viewportMid = headerHeight + (window.innerHeight - headerHeight) * 0.3;
    var closestIndex = 0;
    var closestDist = Infinity;

    for (var i = 0; i < mediaItems.length; i++) {
      var rect = mediaItems[i].getBoundingClientRect();
      var itemMid = rect.top + rect.height / 2;
      var dist = Math.abs(itemMid - viewportMid);
      if (dist < closestDist) {
        closestDist = dist;
        closestIndex = i;
      }
    }

    setActiveThumbnail(thumbnails, closestIndex);
  }

  // ============================================================
  //  MOBILE: 303 Avenue–style progress bar overlaid on images
  // ============================================================

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function initMobileProgress() {
    if (!isMobile()) return;
    if (document.querySelector('.cs-gallery-progress')) return;

    var slider = document.querySelector('.product__media-list');
    if (!slider) return;

    var items = slider.querySelectorAll('.product__media-item');
    if (items.length < 2) return;

    var totalSlides = items.length;

    // Create progress bar container
    var progressContainer = document.createElement('div');
    progressContainer.className = 'cs-gallery-progress';

    var progressBar = document.createElement('div');
    progressBar.className = 'cs-gallery-progress__bar';
    progressContainer.appendChild(progressBar);

    // Insert inside the slider-component wrapper for proper overlay on images
    var sliderComp = slider.closest('slider-component');
    var insertTarget = sliderComp || slider.closest('media-gallery') || slider.closest('.product__media-wrapper');
    if (insertTarget) {
      insertTarget.style.position = 'relative';
      insertTarget.appendChild(progressContainer);
    }

    // Set bar width after appending to DOM (so it gets rendered)
    var barWidthPct = (100 / totalSlides);
    progressBar.style.cssText = 'display:block!important;position:absolute!important;top:0!important;left:0!important;height:2px!important;min-height:2px!important;background:#1a1a1a!important;border-radius:1px!important;width:' + barWidthPct + '%!important;transition:none!important;will-change:transform!important;';

    // Track scroll position → move bar via transform (real-time, no debounce)
    function updateProgress() {
      var scrollLeft = slider.scrollLeft;
      var maxScroll = slider.scrollWidth - slider.offsetWidth;
      if (maxScroll <= 0) return;
      var progress = scrollLeft / maxScroll;
      var moveX = progress * (totalSlides - 1) * 100;
      progressBar.style.transform = 'translateX(' + moveX + '%)';
    }

    slider.addEventListener('scroll', function () {
      requestAnimationFrame(updateProgress);
    }, { passive: true });

    // Initial position
    updateProgress();
  }

  function removeMobileProgress() {
    var el = document.querySelector('.cs-gallery-progress');
    if (el) el.remove();
  }

  // ---- Polling init: wait for Dawn to render ----
  var attempts = 0;
  function tryInit() {
    initGallery();
    initMobileProgress();
    var gallery = document.querySelector('media-gallery.product__column-sticky');
    if (gallery && gallery.getAttribute('data-' + INIT_FLAG)) return;
    if (isMobile() && document.querySelector('.cs-gallery-progress')) return;
    attempts++;
    if (attempts < 50) setTimeout(tryInit, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(tryInit, 50);
    });
  } else {
    setTimeout(tryInit, 50);
  }

  // Re-init on resize (desktop ↔ mobile switch)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (isMobile()) {
        initMobileProgress();
      } else {
        removeMobileProgress();
        var gallery = document.querySelector('media-gallery.product__column-sticky');
        if (gallery) gallery.removeAttribute('data-' + INIT_FLAG);
        attempts = 0;
        tryInit();
      }
    }, 200);
  });
})();
